import React from 'react'
import { Icon } from './icon'
import './tree.css'

/**
 * Tree
 */
export const Tree = ({ nodes = [], children }) => {
    return (
        <div className="tree">
            {nodes}
            {children}
        </div>
    )
}

/**
 * Tree Node
 */
export const TreeNode = ({ icon = 'folder', label, tooltip, open=false, children, actions }) => {
    return (
        <details className="tree-node" open={open}>
            <summary className="tree-item">
                { icon ? <Icon icon={icon} size="small" small /> : null }
                <div className="label">{label}</div>
                <div className="actions">{actions}</div>
            </summary>
            {children}
        </details>
    )
}

/**
 * Tree Item
 */
export const TreeItem = ({ id, icon = 'description', label, actions, onSelect }) => {

    function select() {
        if (onSelect) onSelect(id)
    }

    return (
        <div className="tree-item final" onClick={select}>
            <Icon icon={icon} size="small" small />
            <div className="label">{label}</div>
            <div className="actions">{actions}</div>
        </div>
    )
} 